import { useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import EventsData from "../data/events.json";
import EventsCatalog from "../data/events-catalog.json";
import GLData from "../data/gl.json";
import { useNavigate } from "react-router-dom";

export default function AdminNavbar() {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);

    const handleNavClick = () => setExpanded(false);

    return (
        <Navbar
            expand="lg"
            expanded={expanded}
            className="bg-body-tertiary"
            style={{
                padding: "10px",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
            }}
        >
            <Container style={{ marginLeft: "0", maxWidth: "100%" }}>
                <Navbar.Brand style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
                    <img
                        src="/logo192.png"
                        style={{ height: "30px", marginRight: "10px" }}
                        alt="logo"
                    />
                    NSSC Admin
                </Navbar.Brand>

                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={() => setExpanded(expanded ? false : true)}
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <LinkContainer to="/" onClick={handleNavClick}>
                            <Nav.Link>All Registrations</Nav.Link>
                        </LinkContainer>

                        <NavDropdown title="Event Registrations" id="event-nav-dropdown">
                            {Object.keys(EventsCatalog)
                                .sort((a, b) => Number(a) - Number(b))
                                .map((eid) => (
                                    <LinkContainer
                                        to={`/event/${eid}/`}
                                        key={eid}
                                        onClick={handleNavClick}
                                    >
                                        <NavDropdown.Item>{EventsCatalog[eid].name}</NavDropdown.Item>
                                    </LinkContainer>
                                ))}
                        </NavDropdown>

                        <NavDropdown title="Student Ambassadors" id="sa-nav-dropdown">
                            <LinkContainer to="/SA/" onClick={handleNavClick}>
                                <NavDropdown.Item>Selected Student Ambassadors</NavDropdown.Item>
                            </LinkContainer>
                            <NavDropdown.Divider />
                            <LinkContainer to="/SA/reg/" onClick={handleNavClick}>
                                <NavDropdown.Item>Student Ambassador Registrations</NavDropdown.Item>
                            </LinkContainer>
                        </NavDropdown>

                        <LinkContainer to="/payments" onClick={handleNavClick}>
                            <Nav.Link>Payments</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/orders" onClick={handleNavClick}>
                            <Nav.Link>Store Orders</Nav.Link>
                        </LinkContainer>

                        <NavDropdown title="GL/WS Attendance" id="gl-nav-dropdown">
                            {Object.keys(GLData)
                                .sort((a, b) => Number(a) - Number(b))
                                .map((val) => (
                                    <LinkContainer
                                        to={`/gl/attendance/${val}/`}
                                        key={val}
                                        onClick={handleNavClick}
                                    >
                                        <NavDropdown.Item>{GLData[val].name}</NavDropdown.Item>
                                    </LinkContainer>
                                ))}
                        </NavDropdown>

                        <NavDropdown title="Events Attendance" id="event-attendance-dropdown">
                            {Object.keys(EventsCatalog)
                                .sort((a, b) => Number(a) - Number(b))
                                .map((eid) => (
                                    <LinkContainer
                                        to={`/event/attendance/${eid}/`}
                                        key={eid}
                                        onClick={handleNavClick}
                                    >
                                        <NavDropdown.Item>{EventsCatalog[eid].name}</NavDropdown.Item>
                                    </LinkContainer>
                                ))}
                        </NavDropdown>

                        <LinkContainer to="/winners" onClick={handleNavClick}>
                            <Nav.Link>Winners</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/halls" onClick={handleNavClick}>
                            <Nav.Link>Halls</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/events/manage" onClick={handleNavClick}>
                            <Nav.Link>Event Management</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/queries" onClick={handleNavClick}>
                            <Nav.Link>Queries</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/qa" onClick={handleNavClick}>
                            <Nav.Link>Question QA</Nav.Link>
                        </LinkContainer>
                    </Nav>

                    {localStorage.getItem("nssc-admin-token") && (
                        <Button
                            variant="danger"
                            className="ms-2"
                            onClick={(e) => {
                                e.preventDefault();
                                localStorage.removeItem("nssc-admin-token");
                                navigate("/login");
                                setExpanded(false);
                            }}
                        >
                            <i className="fas fa-sign-out-alt" /> Logout
                        </Button>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
